export default __webpack_public_path__ + "static/media/image3.984be97e.png";